import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function SydneyPassIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = "primary";
  const color = props.color || defaultColor;
  return (
      <SvgIcon
          {...props}
          color={color}
          xmlns="http://www.w3.org/2000/svg"
          x={0}
          y={0}
          viewBox="0 0 24 24"
          xmlSpace="preserve"
          enableBackground="new 0 0 24 24"
          titleAccess="SydneyPass">
          <path
              fillRule="evenodd"
              d="M2.25 0C1.037 0 0 .952 0 2.19v2.22l.75.001H0c0 .743.555 1.338 1.258 1.45 1.467.234 2.503 1.441 2.503 2.81 0 1.37-1.036 2.578-2.503 2.812h-.001C.555 11.597 0 12.191 0 12.933v2.217c0 1.238 1.037 2.19 2.25 2.19h6a.75.75 0 0 0 0-1.5h-6c-.443 0-.75-.338-.75-.69v-2.186c2.148-.347 3.76-2.143 3.76-4.292 0-2.15-1.612-3.946-3.76-4.292V2.19c0-.353.307-.69.75-.69h19.5c.443 0 .75.337.75.69v2.188c-1.816.298-3.28 1.642-3.659 3.416a.75.75 0 0 0 1.468.312c.242-1.14 1.197-2.045 2.435-2.248.701-.112 1.255-.707 1.256-1.448V2.19C24 .952 22.963 0 21.75 0H2.25Zm-.755 12.964v-.005l.001-.005a.058.058 0 0 0 .004-.02h-.01l-.114-.71.113.71H.75h.74l.004.026a.03.03 0 0 1-.004.005c-.003.003-.003 0 .005 0ZM9 12.27a.75.75 0 0 0-1.5 0v1.44a.75.75 0 0 0 1.5 0v-1.44ZM8.25 7.2a.75.75 0 0 1 .75.75v1.44a.75.75 0 1 1-1.5 0V7.95a.75.75 0 0 1 .75-.75ZM9 3.63a.75.75 0 1 0-1.5 0v1.44a.75.75 0 1 0 1.5 0V3.63Zm1.5 12.96c0-3.624 3.051-6.51 6.75-6.51S24 12.966 24 16.59c0 3.624-3.051 6.51-6.75 6.51s-6.75-2.886-6.75-6.51Zm6.75-5.01c-2.929 0-5.25 2.272-5.25 5.01s2.321 5.01 5.25 5.01 5.25-2.272 5.25-5.01-2.321-5.01-5.25-5.01Zm.75 2.465a.75.75 0 0 0-1.5 0v2.545c0 .414.336.75.75.75h2.652a.75.75 0 0 0 0-1.5H18v-1.795Z"
              clipRule="evenodd"
          />
      </SvgIcon>
  );
}
